import React, { Component, Fragment } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Error from '../helper/Error';
import SimpleTable from '../helper/SimpleTable';
import DeleteDialog from '../helper/Dialogs';
import { authContext } from "../../context/AuthContext";

class GeoGroups extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);
        this.state = {
            geoGroups: [],
            isDeleteDialogOpen: false,
            error: null,
            itemToDelete: ''
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/administration/geoGroup');
    }

    onEdit = (tag) => {
        let id = tag;
        this.props.history.push('/administration/geoGroup/' + id);
    }

    openDeleteDialog = (tag) => {
        this.setState({ itemToDelete: tag });
        this.handleDeleteDialogOpen();
    }

    onDelete = (event) => {
        this.handleDeleteDialogClose();
        let id = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });

        let token = sessionStorage.getItem('accessToken');

        axios('/api/geoGroup/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((res) => {
            this.refresh();
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });
    }

    refresh() {
        axios.get('/api/geoGroup', {
        }).then((res) => {
            this.setState({
                geoGroups: res.data.geogroups
            });
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    componentDidMount() {
        this.refresh();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    render() {
        const { classes } = this.props;
        const disableAction = this.context.roles.isClassroomTrainingAdmin === 1? false:true;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.error !== null) return <Error />;

        let enhancedData = [];
        enhancedData = this.state.geoGroups.map((arrayItem) => {
            let item = JSON.parse(JSON.stringify(arrayItem));
            item.actionsDisabled = {
                edit: false,
                delete: disableAction
            }
            return item;
        });

        const tableCells = [
            { id: 'name', label: 'Name', centered: false }
        ];

        const actionButtons = [
            { icon: "edit", action: this.onEdit, delete: false },
            { icon: "delete", action: this.openDeleteDialog,  delete: true }
        ];

        return (
            <Fragment>
                <PageHeader
                    title={"Regions"}
                    actionButtons={[{ label: "Add new region", action: this.onNew, disabled: disableAction }]}
                />

                <div>
                    <div className={classes.root}>
                        <div>
                            <br />

                            <SimpleTable
                                data={enhancedData}
                                cellKey={"ID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={true}
                            />
                            <DeleteDialog
                                open={this.state.isDeleteDialogOpen}
                                onClose={this.handleDeleteDialogClose}
                                onDelete={this.onDelete}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// export default GeoGroups;
export default withStyles(styles, { withTheme: true })(GeoGroups);
